import apiClient from '@u/apiClient'
import GetAccountingCodeListController from '@/wayfinder/actions/App/Http/Controllers/AccountingCode/GetAccountingCodeListController'
import GetAccountingCodeByIdController from '@/wayfinder/actions/App/Http/Controllers/AccountingCode/GetAccountingCodeByIdController'
import CreateAccountingCodeController from '@/wayfinder/actions/App/Http/Controllers/AccountingCode/CreateAccountingCodeController'
import UpdateAccountingCodeController from '@/wayfinder/actions/App/Http/Controllers/AccountingCode/UpdateAccountingCodeController'
import DeleteAccountingCodeController from '@/wayfinder/actions/App/Http/Controllers/AccountingCode/DeleteAccountingCodeController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

export default {
  // region Fetch
  fetchAccountingCodeList: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAccountingCodeListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchAccountingCode: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAccountingCodeByIdController.get({ accounting_code: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewAccountingCode({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetNewModelController.get({ query: { model: 'accountingCode' } })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region store
  storeAccountingCode: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateAccountingCodeController.post(), payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  updateAccountingCode: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAccountingCodeController.put({ accounting_code: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion
  // region delete
  deleteAccountingCodeById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteAccountingCodeController.delete.delete({
            accounting_code: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteAccountingCodeById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteAccountingCodeController.undo.get({
            accounting_code: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
